import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.CARTOON_FACTORY;

export const LEVEL_COUNT = 2;
export const ITEMS_PER_ROUND = 3;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  RECORDING: 'RECORDING',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
};

export const REDUX_ACTIONS = {
  FETCH_CURRICULUMS: 'FETCH_CURRICULUMS',
  FETCH_CURRICULUMS_FULLFILLED: 'FETCH_CURRICULUMS_FULLFILLED',
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  SAVE_RECORDING_URL: 'SAVE_RECORDING_URL',
  RESET_RECORDING_URLS: 'RESET_RECORDING_URLS',
  SAVE_FLUENCY_RESULTS: 'SAVE_FLUENCY_RESULTS',
};

export const SOAPBOX_RECORDING_DURATION = 60000;
